/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { css } from 'styled-components'
import {
  dealInAnim,
  bankerDealOutAnim,
  playerDealOutAnim,
  scaleAnim,
  flipAnim,
  flickleAnim,
} from './animationKeyframes'

export const dealIn = css`
    animation: ${dealInAnim} 0.4s forwards;
  `
export const bankerDealOut = css`
    animation: ${bankerDealOutAnim} 0.4s forwards;
  `
export const playerDealOut = css`
    animation: ${playerDealOutAnim} 0.4s forwards;
  `
export const scale = css`
    animation: ${scaleAnim} 0.6s forwards 0.3s;
  `
export const flip = css`
    animation: ${flipAnim} 0.4s forwards;
  `
export const flickle = css`
    animation: ${flickleAnim} 0.8s infinite;
  `
